module.exports = __webpack_public_path__ + "img/closeEye.4a828d77.svg";